<template>
  <section v-if="items" class="def-bread-crumbs">
    <div v-for="(item, i) in items" :key="i" class="def-bread-crumbs__item">
      <a v-if="i !== items.length - 1 || i === 0" :href="item.LINK" class="def-bread-crumbs__link">
        <svg v-if="screenWidth < 768" class="def-bread-crumbs__arrow">
          <use xlink:href="#svg-arrow-left"></use>
        </svg>
        <span v-html="item.TITLE"></span>
      </a>
      <!--      seo requirements-->
      <span v-else class="def-bread-crumbs__link">
        <svg v-if="screenWidth < 768" class="def-bread-crumbs__arrow">
          <use xlink:href="#svg-arrow-left"></use>
        </svg>
        <span v-html="item.TITLE"></span>
      </span>

      <svg v-if="i !== items.length - 1" class="def-bread-crumbs__next">
        <use xlink:href="#svg-arrow-right"></use>
      </svg>
    </div>
  </section>
</template>

<script lang="ts" setup>
import useScreenWidth from '@use/useScreenWidth';
import { useResultsStore } from '@/storePinia/stores/results';
import { computed } from 'vue';
import { IBreadcrumbs } from '@/interfaces';

const props = defineProps<{
  result?: IBreadcrumbs;
}>();

const screenWidth = useScreenWidth();
const resultsStore = useResultsStore();

const breadcrumbs = computed(() => resultsStore.breadcrumbs);

const items = computed(() => {
  if (screenWidth.value < 768) {
    if (props.result) {
      return props.result.slice(props.result.length - 2, props.result.length - 1);
    }
    return breadcrumbs.value?.slice(breadcrumbs.value.length - 2, breadcrumbs.value.length - 1);
  }
  if (props.result) {
    return props.result;
  }
  return breadcrumbs.value;
});
</script>

<style lang="scss" scoped>
.def-bread-crumbs {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 16px 0;
  font-size: 14px;
  font-weight: 500;
  line-height: 125%;
  @include point-md {
    padding: 24px 0;
  }
  &__item {
    display: flex;
    align-items: center;
    &:last-child {
      cursor: default;
    }
  }
  &__link {
    display: flex;
    align-items: center;
  }
  span.def-bread-crumbs__link {
    color: #5f5f67;
  }
  &__arrow {
    display: inline-block;
    width: 20px;
    height: 20px;
    margin-right: 8px;
    fill: #5f5f67;
    flex-shrink: 0;
  }
  &__next {
    fill: #5f5f67;
    width: 20px;
    height: 20px;
    margin: 0 8px;
  }
}
</style>
